"use client";

import { usePathname } from "next/navigation";
// import { posthog } from "posthog-js";
import { track } from "@vercel/analytics";

interface BannerTrackerProps {
  bannerData: {
    title: string;
    external_url: string;
    id: string;
  };
  children: React.ReactNode;
  className?: string;
}

export default function BannerTracker({
  bannerData,
  children,
  className,
}: BannerTrackerProps) {
  const pathname = usePathname();

  // Determine page from pathname
  const getPage = () => {
    if (pathname === "/") return "home";
    if (pathname.startsWith("/events")) return "events";
    if (pathname.startsWith("/news")) return "news";
    if (pathname.startsWith("/articles")) return "articles";
    if (pathname.startsWith("/music")) return "music";
    if (pathname.startsWith("/artist")) return "artist";
    if (pathname.startsWith("/watch")) return "watch";

    // Extract first segment for other pages
    const segments = pathname.split("/").filter(Boolean);
    return segments[0] || "home";
  };

  const page = getPage();

  const handleClick = () => {
    // Event name: Clear, action-based, human-readable
    const eventName = "Banner Clicked";

    // Event properties: Structured context for filtering/grouping
    const eventProperties = {
      // Component identification
      component: "festival_ad_banner",
      component_type: "advertisement",

      // Location context
      page,
      pathname,

      // Banner-specific data
      banner_title: bannerData.title,
      external_url: bannerData.external_url,
      id: bannerData.id,

      // Additional context
      // timestamp: new Date().toISOString(),
    };

    // Initialize PostHog if in browser environment
    // if (typeof window !== "undefined") {
    //   posthog.capture(eventName, eventProperties);
    // }

    // Track with Vercel Analytics
    track(eventName, eventProperties);
  };

  return (
    <a
      href={bannerData.external_url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className={className || "block"}
    >
      {children}
    </a>
  );
}
